import { orange } from '@/theme/colors'
import styled from 'styled-components'

export const SectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

export const SectionLabel = styled.div`
	font-size: 0.8rem;
	font-weight: 600;
	color: #374151;
	display: flex;
	align-items: center;
	gap: 0.375rem;

	svg {
		width: 14px;
		height: 14px;
		fill: currentColor;
	}
`

export const AddButton = styled.button`
	font-size: 0.75rem;
	font-weight: 600;
	color: ${orange};
	background: none;
	border: none;
	cursor: pointer;
	padding: 0.125rem 0.375rem;
	border-radius: 4px;
	transition: background 0.15s;

	&:hover:not(:disabled) {
		background: rgba(209, 95, 42, 0.08);
	}

	&:disabled {
		opacity: 0.4;
		cursor: not-allowed;
	}
`

export const ThumbnailGrid = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem;
`

export const ThumbnailItem = styled.div`
	position: relative;
	width: 110px;
	height: 110px;
	border-radius: 8px;
	overflow: hidden;
	border: 1px solid #e5e7eb;
	background: #f3f4f6;
	cursor: pointer;
	transition: transform 0.15s ease, box-shadow 0.15s ease;

	&:hover {
		transform: translateY(-1px);
		box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
	}

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`

export const ThumbnailDocIcon = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 4px;
	color: #9ca3af;

	span {
		font-size: 0.7rem;
		font-weight: 600;
		text-transform: uppercase;
		color: #6b7280;
		max-width: 100px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: center;
	}
`

export const RemoveButton = styled.button`
	position: absolute;
	top: 4px;
	right: 4px;
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background: rgba(0, 0, 0, 0.65);
	color: white;
	border: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.7rem;
	line-height: 1;
	padding: 0;
	opacity: 0;
	transition: opacity 0.15s;
	z-index: 2;

	${ThumbnailItem}:hover & {
		opacity: 1;
	}

	&:hover {
		background: rgba(0, 0, 0, 0.85);
	}
`

export const UploadingOverlay = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.375rem 0.625rem;
	background: #f3f4f6;
	border-radius: 6px;
	font-size: 0.75rem;
	color: #6b7280;
`

export const MiniSpinner = styled.div`
	width: 14px;
	height: 14px;
	border: 2px solid #e5e7eb;
	border-top-color: ${orange};
	border-radius: 50%;
	animation: spin 0.6s linear infinite;

	@keyframes spin {
		to { transform: rotate(360deg); }
	}
`

export const EmptyAttachments = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.375rem;
	padding: 0.625rem;
	border: 1px dashed #d1d5db;
	border-radius: 6px;
	background: transparent;
	color: #9ca3af;
	font-size: 0.75rem;
	cursor: pointer;
	transition: all 0.15s;

	&:hover {
		border-color: ${orange};
		color: ${orange};
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.4;
	}
`

export const HiddenInput = styled.input`
	display: none;
`
